import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { Widget } from "@models/widget";
import { map, Observable } from "rxjs";
import { HttpService } from "./http.service";

@Injectable({
    providedIn: 'root'
}) 
export class WidgetService {
    constructor(private http: HttpService) {}

    getWidgetConfig(widgetUid: string): Observable<Widget> {

        return this.http.get(`${environment.apiUrl}/public/initiate-widget?chatWidgetUuid=${widgetUid}`).pipe(map((widgetConfig: any)=>{
            let widgetConfigData: Widget = widgetConfig.data;
            return widgetConfigData;
        }))
    }
}